import {getBoundingClientRect} from './helpers/getBoundingClientRect';

const CLASS_BIG = 'bs-site-logo--big';

export function match(logoElement) {
	return logoElement.classList.contains(CLASS_BIG);
}

export function init(store, logoE, introStageE) {
	const pageContentE = document.querySelector('.bs-content');
	const contentsE = document.querySelectorAll('.bs-site-head-content');
	const contentLogoE = document.querySelector(
		'.bs-site-logo .bs-site-head-content'
	);

	return function update() {
		const {isScrolled} = store.getState();

		logoE.classList[isScrolled ? 'add' : 'remove'](
			'bs-site-logo--scrolled'
		);

		// update page content
		if (pageContentE && contentLogoE) {
			const contentBgHeight = getBoundingClientRect(contentLogoE).height;
			pageContentE.style.paddingTop =
				introStageE === null ? `${contentBgHeight}px` : '0';
		}

		contentsE.forEach((e) => {
			e.classList[isScrolled ? 'add' : 'remove'](
				'bs-site-head-content--scrolled'
			);
		});
	};
}
